export var fontFamily = ['Manrope', 'Roboto', 'arial', 'sans-serif'].join(',');
export var DEFINED_TEXT_VARIANTS = [
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'subhead1',
    'body1',
    'body1Link',
    'body1Semibold',
    'body2',
    'body2Link',
    'body2Semibold',
    'body2Medium',
    'body3',
    'body3Link',
    'body3Semibold',
    'overline1',
    'overline2',
    'tableH1',
    'tableH1ExtraBold',
    'table1',
    'table1Link',
    'table1Semibold',
    'table1Superscript',
    'tableHeaderOLD',
    'table2',
    'table2Link',
    'tag1Medium',
    'tag2Medium',
    'tag1Semibold',
    'tag2Semibold',
    'tag3Semibold',
    'searchSuggestion',
    'searchSuggestionBold',
    // Termina specific
    'subhead3',
];
export default {
    // Headers
    h1: {
        fontFamily: fontFamily,
        fontSize: '60px',
        lineHeight: '72px',
        fontWeight: '500',
        fontStyle: 'normal',
        letterSpacing: '-1.5px'
    },
    h2: {
        fontFamily: fontFamily,
        fontSize: '48px',
        lineHeight: '64px',
        fontWeight: '500',
        fontStyle: 'normal',
        letterSpacing: '-0.5px'
    },
    h3: {
        fontFamily: fontFamily,
        fontSize: '32px',
        lineHeight: '44px',
        fontWeight: '600',
        fontStyle: 'normal'
    },
    h4: {
        fontFamily: fontFamily,
        fontSize: '24px',
        lineHeight: '32px',
        fontWeight: '600',
        fontStyle: 'normal'
    },
    h5: {
        fontFamily: fontFamily,
        fontSize: '20px',
        lineHeight: '28px',
        fontWeight: '700',
        fontStyle: 'normal'
    },
    h6: {
        fontFamily: fontFamily,
        fontSize: '18px',
        lineHeight: '24px',
        fontWeight: '700',
        fontStyle: 'normal',
        letterSpacing: '0.15px'
    },
    // Subtitles
    subhead1: {
        fontFamily: fontFamily,
        fontSize: '18px',
        lineHeight: '24px',
        fontWeight: '600',
        fontStyle: 'normal'
    },
    // Body
    body1: {
        fontFamily: fontFamily,
        fontSize: '16px',
        lineHeight: '24px',
        fontWeight: '400',
        fontStyle: 'normal',
        letterSpacing: '-0.005em'
    },
    body1Link: {
        fontFamily: fontFamily,
        fontSize: '16px',
        lineHeight: '24px',
        fontWeight: '500',
        fontStyle: 'normal',
        letterSpacing: '-0.005em'
    },
    body1Semibold: {
        fontFamily: fontFamily,
        fontSize: '16px',
        lineHeight: '24px',
        fontWeight: '600',
        fontStyle: 'normal'
    },
    body2: {
        fontFamily: fontFamily,
        fontSize: '14px',
        lineHeight: '20px',
        fontWeight: '400',
        fontStyle: 'normal',
        letterSpacing: '-0.005em'
    },
    body2Link: {
        fontFamily: fontFamily,
        fontSize: '14px',
        lineHeight: '20px',
        fontWeight: '500',
        fontStyle: 'normal',
        letterSpacing: '-0.005em'
    },
    body2Semibold: {
        fontFamily: fontFamily,
        fontSize: '14px',
        lineHeight: '20px',
        fontWeight: '600',
        fontStyle: 'normal'
    },
    body2Medium: {
        fontFamily: fontFamily,
        fontSize: '14px',
        fontWeight: 500,
        lineHeight: '20px' /* 142.857% */,
        letterSpacing: '-0.035px',
        fontStyle: 'normal'
    },
    body3: {
        fontFamily: fontFamily,
        fontSize: '12px',
        lineHeight: '16px',
        fontWeight: '400',
        fontStyle: 'normal'
    },
    body3Link: {
        fontFamily: fontFamily,
        fontSize: '12px',
        lineHeight: '16px',
        fontWeight: '500',
        fontStyle: 'normal'
    },
    body3Semibold: {
        fontFamily: fontFamily,
        fontSize: '12px',
        lineHeight: '16px',
        fontWeight: '600',
        fontStyle: 'normal'
    },
    overline1: {
        fontFamily: fontFamily,
        fontSize: '12px',
        lineHeight: '16px',
        fontWeight: '600',
        fontStyle: 'normal',
        letterSpacing: '0.01em',
        textTransform: 'uppercase'
    },
    overline2: {
        fontFamily: fontFamily,
        fontSize: '10px',
        lineHeight: '14px',
        fontWeight: '600',
        fontStyle: 'normal',
        letterSpacing: '0.01em',
        textTransform: 'uppercase'
    },
    // Table
    tableH1: {
        fontFamily: fontFamily,
        fontSize: '14px',
        lineHeight: '16px',
        fontWeight: '600',
        fontStyle: 'normal',
        letterSpacing: '-0.02em'
    },
    tableH1ExtraBold: {
        fontFamily: fontFamily,
        fontSize: '14px',
        lineHeight: '16px',
        fontWeight: '800',
        fontStyle: 'normal',
        letterSpacing: '-0.0275em'
    },
    table1: {
        fontFamily: fontFamily,
        fontSize: '14px',
        lineHeight: '20px',
        fontWeight: '400',
        fontStyle: 'normal',
        letterSpacing: '-0.02em'
    },
    table1Link: {
        fontFamily: fontFamily,
        fontSize: '14px',
        lineHeight: '20px',
        fontWeight: '500',
        fontStyle: 'normal',
        letterSpacing: '-0.02em'
    },
    table1Semibold: {
        fontFamily: fontFamily,
        fontSize: '14px',
        lineHeight: '20px',
        fontWeight: '600',
        fontStyle: 'normal',
        letterSpacing: '-0.02em'
    },
    table1Superscript: {
        // Similar to tableH1
        fontFamily: fontFamily,
        fontSize: '14px',
        lineHeight: '20px',
        fontWeight: '400',
        fontStyle: 'normal',
        letterSpacing: '-0.02em'
    },
    table2: {
        fontFamily: fontFamily,
        fontSize: '12px',
        lineHeight: '16px',
        fontWeight: '400',
        fontStyle: 'normal',
        letterSpacing: '-0.02em'
    },
    table2Link: {
        fontFamily: fontFamily,
        fontSize: '12px',
        lineHeight: '16px',
        fontWeight: '500',
        fontStyle: 'normal',
        letterSpacing: '-0.02em'
    },
    tableHeaderOLD: {
        fontFamily: fontFamily,
        fontSize: '14px',
        lineHeight: '16px',
        fontWeight: '700',
        fontStyle: 'normal',
        letterSpacing: '-0.02em'
    },
    // Tags
    tag1Medium: {
        fontFamily: fontFamily,
        fontSize: '14px',
        lineHeight: '16px',
        fontWeight: '500',
        fontStyle: 'normal',
        letterSpacing: '-0.02em'
    },
    tag2Medium: {
        fontFamily: fontFamily,
        fontSize: '12px',
        lineHeight: '16px',
        fontWeight: '500',
        fontStyle: 'normal',
        letterSpacing: '-0.02em'
    },
    tag1Semibold: {
        fontFamily: fontFamily,
        fontSize: '14px',
        lineHeight: '16px',
        fontWeight: '600',
        fontStyle: 'normal',
        letterSpacing: '-0.02em'
    },
    tag2Semibold: {
        fontFamily: fontFamily,
        fontSize: '12px',
        lineHeight: '16px',
        fontWeight: '600',
        fontStyle: 'normal',
        letterSpacing: '-0.28px'
    },
    tag3Semibold: {
        fontFamily: fontFamily,
        fontSize: '11px',
        lineHeight: '14px',
        fontWeight: '600',
        fontStyle: 'normal',
        letterSpacing: '-0.02em'
    },
    // Misc
    searchSuggestion: {
        fontFamily: fontFamily,
        fontSize: '14px',
        lineHeight: '16px',
        fontWeight: '400',
        fontStyle: 'normal',
        letterSpacing: '-0.01em'
    },
    searchSuggestionBold: {
        fontFamily: fontFamily,
        fontSize: '14px',
        lineHeight: '16px',
        fontWeight: '600',
        fontStyle: 'normal',
        letterSpacing: '-0.01em'
    },
    // Termina specific
    subhead3: {
        fontFamily: "Termina, ".concat(fontFamily),
        fontSize: '14px',
        lineHeight: '16px',
        fontWeight: '600',
        fontStyle: 'normal'
    }
};
